import { useEffect } from 'react'
import CustomHead from 'components/common/HeadMeta/HeadMeta'
import Template from 'components/downloads/DownloadOD'

const Download: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.remove('non-chat')
  }, [])
  return (
    <>
      <CustomHead
        keyword={'DevOps アジャイル開発 クラウド 仮想化 マイクロサービス'}
        image={'https://www.i3design.jp/ogp_logo.png'}
        url={'https://www.i3design.jp/download/od/'}
        title="継続開発プラン | 資料ダウンロード | i3DESIGN アイスリーデザイン"
        description="i3DESIGN（アイスリーデザイン）が提供する継続開発で実施するプランの詳細を掲載しております。クライアント様向けの専任開発チームを構築し、低コストかつスピーディーで柔軟な稼働が可能なプランをご紹介しております。"
      />
      <Template />
    </>
  )
}

export default Download
